import { useMemo } from 'react';
import { type IReference } from '../references/IReference.ts';
import { materializeReference } from './materializeReferencePath.ts';

export function useMaterializeReference(name: string, reference: IReference) {
  const result = useMemo(() => {
    return materializeReference(reference, name);
  }, [name, reference]);

  return result;
}
